<template>
  <div :class="isRequestLogOpen && 'd-flex'">
    <custom-simple-table
      :item="details"
      i18-path="requests.fields"
      :table-keys="tableKeys"
      :specific-classes="active.work_order_group_type_nat ? [] : cssClasses"
      :attributes-obj-ref="attributesObjRef"
    />
    <div :class="isRequestLogOpen && 'mx-2'">
      <span class="caption font-weight-bold">
        {{ generateMessage('requests.fields.' + 'customer_comment') }} :
      </span>
      <span class="caption">
        {{ formatField(active, 'customer_comment') }}
      </span>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { generateMessage } from '@/utils/i18n';
import { formatField } from '@/business/utils/display';
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import { ATTRIBUTES_OBJ_REF_REQUESTS_TREATED } from '@/store/modules/requests/treated';

const { mapGetters, mapActions } = createNamespacedHelpers('requests');

export default {
  name: 'RequestInfos',
  components: { CustomSimpleTable },
  props: {
    isRequestLogOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['active']),
    details() {
      return {
        ...this.active,
        work_order_group_type_name:
          this.active.work_order_group_type_name &&
          `${this.active.work_order_group_type_name} (${this.active.intervention_contract_period}h)`,
      };
    },
  },
  data() {
    return {
      attributesObjRef: ATTRIBUTES_OBJ_REF_REQUESTS_TREATED,
      tableKeys: [
        'id',
        'status',
        'rejected',
        'transmitted',
        'signalisation_datetime',
        'limit_datetime',
        'work_order_group_type_name',
        'customer_name',
        'customer_phone',
        'customer_type',
        'location',
      ],
      cssClasses: [
        '',
        '',
        '',
        '',
        '',
        '',
        'font-weight-bold violet-eggplant--text',
        '',
        '',
        '',
        '',
      ],
    };
  },
  methods: {
    ...mapActions(['removeCurrent']),
    generateMessage,
    formatField,
    handleCloseClick() {
      this.removeCurrent(this.active.id);
      this.$store.dispatch('boilerplate/setModalOpened', {
        component: 'RequestDialog',
      });
    },
    handleRemoveClick() {
      this.$store.dispatch('boilerplate/setModalOpened', {
        component: 'RequestDialog',
      });
    },
  },
};
</script>
